import React, { useEffect, useMemo, useState } from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import SwitchPanel from './SwitchPanel';
import TopPanel from './TopPanel';
import { RootStore } from '@/models';

interface ModelState {
  RTCInstance?: RootStore['rtc'];
  simultaneous?: RootStore['simultaneousInterpretation'];
  meeting?: RootStore['meeting'];
  members?: RootStore['members'];
}

interface Props extends ModelState {
  children: Element | React.ReactNode;
}

export enum SWITCH_CHANNEL_STEP {
  SWITCH = 'switch',
  TOP = 'top',
}

const SwitchChannelH5: React.FC<Props> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    meeting: store.meeting,
    simultaneous: store.simultaneousInterpretation,
    members: store.members,
  };
})(
  observer((props) => {
    const { simultaneous, meeting, members, children } = props;
    const { info } = meeting || {};
    const { meetingId, channelId } = info || {};
    const { allChannels, currentChannelItem, mainChannelVolume } = simultaneous || {};
    const [currentStep, setCurrentStep] = useState(SWITCH_CHANNEL_STEP.TOP);
    const [visible, setVisible] = useState<boolean>(false);

    useEffect(() => {
      // 服务端说这个参数必填
      if (channelId) {
        // TODO：getChannels解构使用的话 this就变成null 所以以对象的形式调用
        simultaneous?.getChannels({
          meetingId: `${meetingId}`,
          channelId: `${channelId}`,
        });
      }
    }, [meetingId, channelId]);

    useEffect(() => {
      // 如果在打开当前页面的时候  恰好关闭了同声传译, 关闭当前页面
      if (!simultaneous?.interpretationStatus) {
        setVisible(false);
      }
    }, [simultaneous?.interpretationStatus]);

    return (
      <>
        <TopPanel
          next={() => {
            setCurrentStep(SWITCH_CHANNEL_STEP.SWITCH);
            // setVisible(true);
          }}
          visible={visible}
          show={() => {
            setVisible(true);
          }}
          hide={() => {
            setVisible(false);
          }}
        >
          {children}
        </TopPanel>
        {/* {currentStep === SWITCH_CHANNEL_STEP.SWITCH && ( */}
        <SwitchPanel
          visible={currentStep === SWITCH_CHANNEL_STEP.SWITCH}
          back={() => {
            setCurrentStep(SWITCH_CHANNEL_STEP.TOP);
            // setVisible(false);
          }}
        >
          {children}
        </SwitchPanel>
        {/* )} */}
      </>
    );
  })
);
export default SwitchChannelH5;
